import { gql } from "graphql-request";

import { client } from "@krea/customer-features/graphql";
import { LOAN_APPLICATION_EXTENDED_FRAGMENT } from "@krea/customer-features/graphql/loan-application/loan-application-extended.fragment";
import { ILoanApplicationExtended } from "@krea/customer-features/types/loanApplication";

const GET_CURRENT_LOAN_APPLICATION_QUERY = gql`
  query FetchCurrentLoanApplication {
    me {
      currentLoanApplication {
        id
        shouldTrackDraftConversion
        shouldTrackRateForecastExecutedConversion

        ...LoanApplicationExtendedFragment
      }
    }
  }
  ${LOAN_APPLICATION_EXTENDED_FRAGMENT}
`;

interface IGetCurrentLoanApplication {
  me: {
    currentLoanApplication: ILoanApplicationExtended | null;
  } | null;
}

export const getCurrentLoanApplication = async () => {
  return client.request<IGetCurrentLoanApplication>(
    GET_CURRENT_LOAN_APPLICATION_QUERY,
  );
};
